// Header initialization
document.addEventListener('DOMContentLoaded', function() {
  // Initialize header resize observers
  if (typeof theme !== 'undefined' && theme.setUpHeaderResizeObservers) {
    theme.setUpHeaderResizeObservers();
  }
});

// Popup functionality for Room Visualizer
document.addEventListener("DOMContentLoaded", function() {
  var button = document.getElementById("popupButton1");
  var container = document.getElementById("popupContainer");

  if (!button || !container) return; // Exit if elements don't exist

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function setPopupHeight(popupDiv) {
    popupDiv.style.height = window.innerHeight + "px";
  }

  button.addEventListener("click", function(event) {
    event.preventDefault();

    // Check if the popup already exists
    var existingPopup = document.getElementById("popupContent1");

    if (existingPopup) {
      // If it exists, remove it and restore body scrolling
      existingPopup.remove();
      document.documentElement.classList.remove("no-scroll");
      document.body.classList.remove("no-scroll");
    } else {
      scrollToTop();

      // If not, create and append the element
      var popupDiv = document.createElement("div");
      popupDiv.id = "popupContent1";
      popupDiv.className = "popup-overlay";

      var contentDiv = document.createElement("div");
      contentDiv.className = "popup-content";
      setPopupHeight(contentDiv); // Set initial height

      // Update height on window resize
      window.addEventListener("resize", function () {
        setPopupHeight(contentDiv);
      });

      var closeButton = document.createElement("button");
      closeButton.className = "popup-close";
      closeButton.textContent = "Close visualizer";
      closeButton.addEventListener("click", function() {
        popupDiv.remove();
        document.documentElement.classList.remove("no-scroll");
        document.body.classList.remove("no-scroll");
        // Redirect to home page
        window.location.href = "/";
      });

      var iframe = document.createElement("iframe");
      iframe.src = "https://pim-client.wizart.ai/fitting-room?api_token=kJpYNqN0ssG9AVgcznkHefULFJaTHWz3t6VSgY3vUHSqVGYUkl8s5FkbTBPj&enabled_shopping_cart=0&is_shown_shopping_cart_prices=0";
      iframe.setAttribute("aria-label", "Wizart Fitting Room.");
      iframe.setAttribute("role", "dialog");
      iframe.setAttribute("allowfullscreen", "");

      // Append elements
      contentDiv.appendChild(closeButton);
      contentDiv.appendChild(iframe);
      popupDiv.appendChild(contentDiv);
      container.appendChild(popupDiv);

      // Disable scrolling on the body
      document.documentElement.classList.add("no-scroll");
      document.body.classList.add("no-scroll");
    }
  });
});

// Check if current page is visualize-it and handle body scroll
document.addEventListener("DOMContentLoaded", function() {
  function checkIfVisualizeItPage() {
    if (window.location.pathname.includes("/pages/visualize-it")) {
      document.documentElement.classList.add("no-scroll");
      document.body.classList.add("no-scroll");
    } else {
      document.documentElement.classList.remove("no-scroll");
      document.body.classList.remove("no-scroll");
    }
  }

  // Run check when page loads
  checkIfVisualizeItPage();

  // Also run check when navigating dynamically (Single Page Apps, etc.)
  window.addEventListener("popstate", checkIfVisualizeItPage);
  window.addEventListener("hashchange", checkIfVisualizeItPage);
});

// Mobile menu drawer functionality
document.addEventListener('DOMContentLoaded', function() {
  const drawer = document.querySelector('[data-mobile-menu-drawer]');
  const overlay = document.querySelector('[data-mobile-menu-overlay]');
  const closeBtn = document.querySelector('[data-mobile-menu-close]');
  const triggers = document.querySelectorAll('[data-mobile-menu-trigger]');
  
  if (!drawer || !overlay || !closeBtn) return; // Exit if elements don't exist
  
  // Store the current scroll position
  let scrollPosition = 0;
  
  function disableBodyScroll() {
    // Store current scroll position
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    // Disable scroll on both html and body
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
    
    // Add class to prevent iOS bounce scroll
    document.documentElement.classList.add('mobile-drawer-open');
    document.body.classList.add('mobile-drawer-open');
  }
  
  function enableBodyScroll() {
    // Restore scroll on both html and body
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    
    // Remove class
    document.documentElement.classList.remove('mobile-drawer-open');
    document.body.classList.remove('mobile-drawer-open');
    
    // Restore scroll position
    window.scrollTo(0, scrollPosition);
  }
  
  function openDrawer() {
    drawer.classList.add('is-open');
    disableBodyScroll();
    
    // Toggle trigger icon
    triggers.forEach(trigger => {
      trigger.classList.add('is-active');
      trigger.setAttribute('aria-label', 'Close mobile menu');
    });
  }
  
  function closeDrawer() {
    drawer.classList.remove('is-open');
    enableBodyScroll();
    
    // Toggle trigger icon
    triggers.forEach(trigger => {
      trigger.classList.remove('is-active');
      trigger.setAttribute('aria-label', 'Open mobile menu');
    });
  }
  
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  });
  
  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  
  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
  
  // Mobile submenu functionality
  function initializeSubmenus() {
    const submenuTriggers = document.querySelectorAll('[data-submenu-trigger]');
    const submenuPanels = document.querySelectorAll('[data-submenu-panel]');
    const backButtons = document.querySelectorAll('[data-submenu-back]');
    
    function openSubmenu(submenuId) {
      const panel = document.querySelector(`[data-submenu-panel][data-submenu-id="${submenuId}"]`);
      if (panel) {
        // Hide main menu content
        const drawerBody = document.querySelector('.mobile-menu-drawer__body');
        if (drawerBody) {
          drawerBody.style.overflow = 'hidden';
        }
        
        // Show submenu
        panel.classList.add('is-active');
      }
    }
    
    function closeSubmenu() {
      const activePanel = document.querySelector('.mobile-submenu.is-active');
      if (activePanel) {
        activePanel.classList.remove('is-active');
        
        // Restore main menu content
        const drawerBody = document.querySelector('.mobile-menu-drawer__body');
        if (drawerBody) {
          drawerBody.style.overflow = 'auto';
        }
      }
    }
    
    // Handle submenu trigger clicks
    submenuTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const submenuId = this.getAttribute('data-submenu-id');
        openSubmenu(submenuId);
      });
    });
    
    // Handle back button clicks
    backButtons.forEach(backBtn => {
      backBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closeSubmenu();
      });
    });
    
    // Close submenu when main drawer is closed
    const originalCloseDrawer = closeDrawer;
    closeDrawer = function() {
      closeSubmenu();
      originalCloseDrawer();
    };
  }
  
  // Initialize submenus
  initializeSubmenus();
}); 